import React, { Fragment } from 'react'
import CardBlog from '../../component/Other/CardBlog'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import SecContact from '../../component/Page/SecContact'
import { NavLink } from 'react-router-dom'

const Blog = () => {
    const blogData = [
        {
            tag: "Plant Care",
            bg: "./../images/bg (3).png",
            title: "The Importance of Soil Quality for Healthy Plant Growth",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg (1).png",
            title: "The Best Plants for Hanging Baskets: A Guide to Elevated Greenery",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg (2).png",
            title: "How to Incorporate Plants into Your Home Office for a Productivity Boost",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },

        {
            tag: "Plant Care",
            bg: "./../images/bg2 (2).png",
            title: "The Importance of Soil Quality for Healthy Plant Growth",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg2 (3).png",
            title: "The Best Plants for Hanging Baskets: A Guide to Elevated Greenery",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg2 (4).png",
            title: "How to Incorporate Plants into Your Home Office for a Productivity Boost",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },

        {
            tag: "Plant Care",
            bg: "./../images/bg2 (5).png",
            title: "The Importance of Soil Quality for Healthy Plant Growth",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg2 (6).png",
            title: "The Best Plants for Hanging Baskets: A Guide to Elevated Greenery",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
        {
            tag: "Design and Decor",
            bg: "./../images/bg2 (1).png",
            title: "How to Incorporate Plants into Your Home Office for a Productivity Boost",
            name: "Arka",
            profile: "./../images/Ellipse 5.png",
            date: "Feb 25, 2020",
        },
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"Our Blog"} to={"Our Blog"} />
                </div>

                <section className="position-relative">
                    <div className="container">
                        <div className="text-center mb-5">
                            <h3 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs quest mb-4'>Bloom & Grow Blog</h3>

                            <div className="wrapper__offsite-tag">
                                <div className="blog wrapper__tag-blog medium font__size--16 text__16-1024">
                                    <div className="item pointer active">
                                        All
                                    </div>
                                    <div className="item pointer">
                                        Plant Care
                                    </div>
                                    <div className="item pointer">
                                        Plant Care
                                    </div>
                                    <div className="item pointer">
                                        Design & Decor
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='row mb-5'>
                            <div className="col-md-6 mb-4 my-md-auto">
                                <img src="./../images/Image.png" className='images__blog-wrap' alt="" />
                            </div>
                            <div className="col-md-6 my-auto">
                                <div className="wrapper__blog-side">

                                    <div className="tag normal font__size--14 text__14-1024">Green Living</div>
                                    <h4 className="semi-bold font__size--24 text__24-1024">The Benefits of Indoor Plants for Your Health and Well-Being</h4>
                                    <p className='normal font__size--14 text__14-1024 color__gray-1'>Are you looking for a way to boost your mood and improve your overall health? Look no further than indoor plants! Not only do they add a touch of greenery to your home, but they also offer a range of health benefits that can improve your physical and mental well-being...</p>
                                    <NavLink to="/blog/detail" className="d-inline-block color__orange">
                                        <div className="d-flex align-items-center">
                                            <span className="medium font__size--16 text__16-1024 mr-2">Read More</span>
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_217_4732)">
                                                    <path d="M1.20211 9.00198C1.28395 8.9887 1.36676 8.98257 1.44963 8.98365H15.5592L15.2516 8.84055C14.9508 8.69821 14.6772 8.50449 14.4431 8.26815L10.4864 4.31147C9.96527 3.81402 9.87771 3.01378 10.2789 2.41541C10.7458 1.77777 11.6412 1.63932 12.2789 2.10622C12.3304 2.14397 12.3793 2.18511 12.4254 2.22938L19.5803 9.38433C20.1395 9.94286 20.14 10.8489 19.5814 11.4081C19.5811 11.4084 19.5807 11.4088 19.5803 11.4092L12.4254 18.5641C11.8658 19.1222 10.9597 19.1209 10.4016 18.5613C10.3577 18.5173 10.3167 18.4704 10.2789 18.421C9.87771 17.8226 9.96527 17.0224 10.4864 16.525L14.4359 12.5611C14.6459 12.3509 14.8872 12.1747 15.1514 12.0388L15.5807 11.8456H1.52838C0.797363 11.8728 0.156012 11.3621 0.0186806 10.6436C-0.107826 9.86348 0.421997 9.12854 1.20211 9.00198Z" fill="#F48148" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_217_4732">
                                                        <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0.405762)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </NavLink>

                                    <div className="profile">
                                        <img src="./../images/Image (1).png" alt="" />
                                        <div className="desc ml-2">
                                            <h5 className="semi-bold font__size--16 text__16-1024 mb-0">By Arka</h5>
                                            <p className="mb-0 normal font__size--12 text__12-1024 color__gray-1">Just now</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {
                                blogData.map((obj) => {
                                    return <div className="col-md-6 col-lg-4 mb-4">
                                        <CardBlog data={obj} />
                                    </div>
                                })
                            }
                        </div>


                    </div>
                </section>

                <SecContact />

                <Footer />
            </div >
        </Fragment >
    )
}

export default Blog